import styled from 'styled-components';

export const Container = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  padding: 0 15px;
`;

export const Complemento = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 5px;
`;

export const TotalItem = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding-right: 5px;

  & + div {
    margin-top: 10px;
  }
`;

export const Produto = styled.div`
  display: -webkit-flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-right: 5px;
  /* padding-right: 10px; */
`;
